module.exports = __webpack_public_path__ + "img/words-bg.ee028d36.png";